<template>
  <div id="app">
      <div class="header_warp">
        <div class="wnds_header" style="background: #fff;">
        <img class="wh_logo" src="../static/img/wnds_logo.png" />
        <el-menu :default-active="activeIndex" class="el-menu-demo" :router="true" mode="horizontal">
          <el-menu-item index="/" class="content">首页</el-menu-item>
          <el-menu-item index="discover" class="content">聆听观止</el-menu-item>
          <el-menu-item index="news"  class="content">资讯动态</el-menu-item>
          <el-menu-item index="search" class="content">读诗嘉宾</el-menu-item>
          <el-menu-item index="advertising" class="content">商务合作</el-menu-item>      
          <el-menu-item index="about" class="content">关于我们</el-menu-item>
          <el-menu-item index="join" class="content">加入我们</el-menu-item>
        </el-menu>
        <div class="wh_cnen">
          <a href="https://www.thepoemforyou.com/dist"><button class="wh_cn wh_lag_active changeLanguage" @click="changeLanguage_cn()">CN</button></a>
          <i class="wh_lag_line"></i>
          <a href="https://www.thepoemforyou.com/dist_en"><button class="wh_en changeLanguage"  @click="changeLanguage_en()">EN</button></a>
        </div>
      </div>
      </div>
      <!-- <router-view></router-view> -->
      <keep-alive><router-view v-if="$route.meta.keepAlive"></router-view></keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
      <div class="wnds_footer">
        <div class="wf_box tcf-flex tcf-justify-justify">
          <div class="wfb_lf">
            <img src="../static/img/wnds_logo_foot.png" alt="">
          </div>
          <div class="wfb_ct">
            <ul class="wfbc_title tcf-flex tcf-justify-justify">
              <li><router-link to="/about" class="content">关于我们</router-link></li>
              <li>／</li>
              <li><router-link to="/advertising" class="content">商务合作</router-link></li>
              <li>／</li>
              <li><a target="_blank" href="https://apphifgrt4h2253.h5.xiaoeknow.com/homepage" class="content">人文课程</a></li>
              <li>／</li>
              <li><a target="_blank" href="https://h5.youzan.com/v2/showcase/feature?alias=1g84l5y0o&amp;reft=1544002965392_1544002968744&amp;spm=f47307477_f45376468_f45376468" class="content">诗意空间</a></li>
              <li>／</li>
              <li><router-link to="/join" class="content">加入我们</router-link></li>
            </ul>
            <ul class="wfbc_body tcf-flex">
              <li class="content">
                公司名称：尚客圈（北京）文化传播有限公司<br/>
                联系电话：15321548593<br/>
                投稿/合作：mkt@bemyguest.com.cn
              </li>
              <li></li>
              <li class="content">
               法律顾问：北京市中闻律师事务所<br/>
               Copyright © 2019 尚客圈（北京）文化传播有限公司
              </li>
            </ul>
          </div>

          <!-- <div class="wfb_rg" @mouseenter="showImg()" @mouseleave="hideImg()">
            <div class="litteIcon" id="litteIcon">
              <img src="../static/img/wnds_app_ios.png" alt="" ><br/><br/>
              <img src="../static/img/wnds_app_and.png" alt=""><br/><br/>
            </div>
            <div class="appCode" id="appCode">
              
            </div>
          </div> -->

          <div class="wfbRight">
            <div class="smallImg" id="smallImg" v-if="!flag && !wxFlag">
              <img src="../static/img/B-az.png" alt="" @mouseenter="showWxImg()">
              <img src="../static/img/B-ios.png" alt="" @mouseenter="showWxImg()">
              <img src="../static/img/B-wx.png" alt="" @mouseenter="showKfImg()">
            </div>

            <!-- <div class="bigImg"> -->
              <img src="../static/img/wndsPro1.png" alt="" id="appImg"  v-if="flag && !wxFlag"  @mouseleave="hideWxImg()">
              <img src="../static/img/wxkf2.jpg" alt="" class="wxImg" v-if="wxFlag && !flag" @mouseleave="hideKfImg()">
            <!-- </div> -->
          </div>

        </div>
        <div class="wf_copy"><a target="_bank" href="http://www.beian.miit.gov.cn/">京ICP备11008914号-2 </a>| <a target="_bank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502042239">京公安网备号：11010502042239</a> | <span @click="blockImg()" style="cursor:pointer;">网络文化经营许可证：京网文（2018）8188-686 号</span> | <span @click="blockImg1()" style="cursor:pointer;">增值电信业务经营许可证：京B2-20181236</span> | Website designed by The Poem For You</div>
        <div class="netLicense" id="netLicense" @click="noneImg()">
          <div class="licenseMask"></div>
          <div class="licenseImageWrap">
            <img class="licenseImage" id="licenseImage" src="../static/img/wl.png" alt="">
          </div>
        </div>

        <div class="netLicense" id="netLicense1" @click="noneImg1()">
          <div class="licenseMask"></div>
          <div class="licenseImageWrap">
            <img class="licenseImage" id="licenseImage" src="../static/img/zx.jpg" alt="">
          </div>
        </div>
        
      </div>
    
  </div>
</template>


<script>
export default {
  name: 'App',
  data() {
    return {
      activeIndex: '/',
      flag:false,
      wxFlag:false
    };
  },
  methods: {
    changeLanguage_en(){
      var CN = document.getElementsByClassName("wh_cn")[0];
      CN.style.color='black';
      var EN = document.getElementsByClassName("wh_en")[0];
      EN.style.color='#658e31';
    },
    //翻译为中文
    changeLanguage_cn(){
      var CN = document.getElementsByClassName("wh_cn")[0];
      CN.style.color='#658e31';
      var EN = document.getElementsByClassName("wh_en")[0];
      EN.style.color='black';
      var content = document.getElementsByClassName("content");
    },
    showImg(){
      document.getElementById("appCode").style.display = "block";
      document.getElementById("litteIcon").style.display = "none";
      this.flag =  true;
    },
    hideImg(){
      document.getElementById("appCode").style.display = "none";
      document.getElementById("litteIcon").style.display = "block";
      this.flag =  false;
    },
    blockImg(){
      document.getElementById("netLicense").style.display = "block";
    },
    noneImg(){
      document.getElementById("netLicense").style.display = "none";
    },
    blockImg1(){
      document.getElementById("netLicense1").style.display = "block";
    },
    noneImg1(){
      document.getElementById("netLicense1").style.display = "none";
    },
    showWxImg(){
      this.flag = true
      this.wxFlag = false
    },
    hideWxImg(){
      this.flag = false
    },
    showKfImg(){
      this.wxFlag = true
      this.flag = false
    },
    hideKfImg(){
      this.flag = false
      this.wxFlag = false
    }
  },

}
</script>
<style >

  .netLicense{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    cursor:pointer;
    display: none;
  }
  .licenseMask {
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.6);
    position: fixed;
  }
  .licenseImageWrap {
    position: relative;
    width: 100%;
    height: 100%;
    text-align: center;
  }
  .licenseImageWrap .licenseImage {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 30%;
    height: auto;
    transform: translate(-50%,-50%);
  }

  body{
    min-width: 1200px;
  }
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* text-align: center; */
    color: #2c3e50;
    display: inline-block;
      /* width: 100%; */
  }
  .header_warp{
    width: 100%;
    background: #fff !important;
  }
  .wnds_header{
     /* background-color: #fff !important; */
    width: 1200px !important;
    margin: 0 auto !important;
    position: relative !important;
   
  }
  .wh_logo{
    position: absolute !important;
    top: 30px !important;
    left: 0px !important;
    /* 10px */
  }
  .wh_cnen {
    font-size: 18px !important;
    line-height: 1px !important;
    color: #7f7f7f !important;
    position: absolute !important;
    top: 40px !important;
    right: 25px !important;
  }
  .wh_lag_line{
    display: inline-block !important;
    width: 1px !important;
    height: 14px !important;
    margin: 0 20px !important;
    background-color: #bfbfbf !important;
  }
  .wh_lag_active{
    color: #658e31 !important;
  }
  .el-menu-demo{
    width: 862px !important;
    margin: 0 auto !important;
    /* margin-left: 215px !important;  */
    /* 170px */
  }
  .changeLanguage{
     cursor: pointer !important;
  }
  .el-menu--horizontal{
    border-bottom: 0 !important;
  }
  .el-menu-item.is-active{
    color: #658e31 !important;
  }
  .el-menu--horizontal>.el-menu-item.is-active{
    color: #658e31 !important;
    border-bottom: 4px solid #658e31 !important;
  }
  .el-menu--horizontal>.el-menu-item{
    /* margin: 0 10px; */
    height: 100px !important; 
    line-height: 100px !important;
  }
  .el-menu-item{
    padding: 0 28px !important;
    font-size: 18px !important;
  }
.wnds_footer {
  width: 100%;
  padding-top: 60px;
  font-family: myfont;
  color: #b0b0b0;
  background-color: #424242;
}
.wf_box {
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 60px;
    /* margin-left: 32px; */
}
.wfb_ct {
    width: 706px;
}
.wfbc_body li:nth-child(2) {
    width: 1px;
    height: 56px;
    margin: 0 40px;
    margin-top: 6px;
    background-color: #9b9b9b;
}
.wfbc_title {
    margin-bottom: 44px;
}
.wfbc_title, .wfbc_title a {
    font-size: 14px;
    line-height: 14px;
    color: #fff;
}
.wfbc_body {
    font-size: 12px;
    line-height: 20px;
}
.wf_copy {
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 12px;
    border-top: 1px solid #737373;
}
.wf_copy a {
    cursor: pointer;
    font-size: 12px;
    color: #b0b0b0;
}
.wfb_rg{
  width: 150px;
  height: 150px;
  cursor: pointer;
}
.appCode{
  width: 150px;
  height: 150px;
  background: #fff;
  display: none;
  z-index: 5;
}
.wnds_footer{
  display: inline-table;
  width: 100%;
}
.appCode img{
  width:150px;
  height: 100%;
  float: left;
}
.changeLanguage{
  border: 0;
  background-color: transparent;
  outline: none;
}

.wfbRight{
  width: 150px;
  height: 150px;
}
.smallImg{
  display: flex;
  flex-direction: column;
}
.smallImg img{
  margin-bottom: 10px;
  width: 105px;
  height: 38px;

}
#appImg,.wxImg{
  width: 150px;
  height: 150px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue